import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { EmailProviderSelectComponent } from '@v2/modules/email-app/components/email-provider-select/email-provider-select.component';
import { GmailImapDialogComponent } from '@v2/modules/email-app/components/gmail-imap-dialog/gmail-imap-dialog.component';
import { EMAIL_APP_STORE } from '@v2/modules/email-app/email-app.store';
import { EmailProvider } from '@v2/modules/email-app/services/email-oauth.service';

@Component({
  selector: 'oiq-email-provider-select-dialog',
  imports: [EmailProviderSelectComponent],
  templateUrl: './email-provider-select-dialog.component.html',
})
export class EmailProviderSelectDialogComponent {
  private store = inject(EMAIL_APP_STORE);
  private dialog = inject(Dialog);
  public dialogRef = inject(DialogRef<any, EmailProviderSelectDialogComponent>);

  onProviderSelected(provider: EmailProvider) {
    this.dialogRef.close();

    if (provider === 'gmail_imap') {
      GmailImapDialogComponent.open(this.dialog);
      return;
    }

    this.store.startOAuthFlow(provider);
  }

  onClose() {
    this.dialogRef.close();
  }
}
